(() => {
    'use strict';

    let stock = {};
    let items = [];
    try {
        const data = JSON.parse(document.querySelector('[data-sb-cart-stock]')?.textContent || '{}');
        stock = data.stock || {};
        items = Array.isArray(data.items) ? data.items : [];
    } catch (_) {
        // Unknown inventory keeps the existing quantity behavior.
    }

    const productForms = '[data-product-form], .formQuickview';
    const controls = `${productForms.split(', ').map(selector => `${selector} [name="quantity"]`).join(', ')}, [data-sb-variant-id]`;

    function limit(input) {
        const form = input.closest(productForms);
        const variantId = input.dataset.sbVariantId || form?.querySelector('[name="id"]')?.value;
        const entry = stock[variantId];
        if (!entry || !Number.isInteger(entry.quantity) || entry.quantity < 0) return null;
        let demand = 0;
        for (const item of items) {
            if (String(item.variant_id) === String(variantId) && item.key !== input.dataset.sbLineKey) {
                demand += item.quantity;
            }
        }
        return Math.max(0, (entry.available === false ? 0 : entry.quantity) - demand);
    }

    function clamp(input, quantity) {
        const maximum = limit(input);
        if (maximum === null) return quantity;
        const minimum = input.name === 'quantity' ? Math.min(1, maximum) : 0;
        return Math.min(maximum, Math.max(minimum, Number.isFinite(Number(quantity)) ? Math.floor(Number(quantity)) : minimum));
    }

    function disable(control, disabled, allowRestore = true) {
        if (disabled && !control.disabled) {
            control.dataset.sbStockDisabled = 'true';
            control.disabled = true;
        } else if (!disabled && control.dataset.sbStockDisabled) {
            delete control.dataset.sbStockDisabled;
            if (allowRestore) control.disabled = false;
        }
    }

    function refresh() {
        document.querySelectorAll(controls).forEach(input => {
            const maximum = limit(input);
            const form = input.closest(productForms);
            const parent = input.parentElement;
            const plus = parent.querySelector('.vela-qty__adjust--plus, [name="plus"]');
            if (input.tagName === 'SELECT') {
                let empty = input.querySelector('[data-sb-empty-quantity]');
                if (maximum === 0 && !empty) {
                    empty = new Option('0', '0');
                    empty.dataset.sbEmptyQuantity = '';
                    input.prepend(empty);
                } else if (maximum !== 0 && empty) {
                    empty.remove();
                    if (!input.value) input.value = '1';
                }
            }
            if (maximum === null) {
                if (input.dataset.sbStockLimited) input.removeAttribute('max');
                delete input.dataset.sbStockLimited;
            } else {
                input.dataset.sbStockLimited = 'true';
                input.setAttribute('max', String(maximum));
                // Existing cart lines are reconciled by Shopify, never silently reduced on render.
                if (form && input.value !== '') input.value = String(clamp(input, input.value));
            }
            if (input.tagName === 'SELECT') {
                Array.from(input.options).forEach(option => {
                    option.disabled = maximum !== null && Number(option.value) > maximum;
                });
            }
            if (plus) disable(plus, maximum !== null && Number(input.value) >= maximum);
            if (!form) return;
            const exhausted = maximum === 0;
            const variantId = form.querySelector('[name="id"]')?.value;
            const available = form.dataset.sbVariantAvailable !== 'false' && stock[variantId]?.available !== false;
            form.querySelectorAll('.btn--add-to-cart').forEach(button => disable(button, exhausted, available));
            const payment = form.querySelector('.shopify-payment-button');
            if (payment) {
                if (exhausted && !payment.hidden) {
                    payment.dataset.sbStockHidden = 'true';
                    payment.hidden = true;
                } else if (!exhausted && payment.dataset.sbStockHidden) {
                    delete payment.dataset.sbStockHidden;
                    payment.hidden = false;
                }
            }
            let status = form.querySelector('[data-sb-quantity-status]');
            if (!status && exhausted) {
                status = document.createElement('p');
                status.dataset.sbQuantityStatus = '';
                status.setAttribute('role', 'status');
                form.append(status);
            }
            if (status) {
                status.hidden = !exhausted;
                status.textContent = exhausted ? 'All available copies are already in your cart, or this condition is out of stock.' : '';
            }
        });
    }

    window.sbQuantity = {
        clamp,
        refresh,
        updateCart(cart) {
            if (Array.isArray(cart.items)) items = cart.items;
            refresh();
        }
    };

    for (const name of ['input', 'change']) {
        document.addEventListener(name, event => {
            if (!event.target.matches(controls)) return;
            const input = event.target;
            if (limit(input) !== null && input.value !== '') input.value = String(clamp(input, input.value));
            refresh();
        }, true);
    }
    document.addEventListener('sb:variant-change', event => {
        const form = event.target.querySelector(productForms);
        if (form) form.dataset.sbVariantAvailable = String(event.detail.available);
        refresh();
    });
    document.addEventListener('submit', event => {
        if (!event.target.matches(productForms)) return;
        const input = event.target.querySelector('[name="quantity"]');
        if (input && limit(input) === 0) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }, true);
    refresh();
})();
